import React from 'react';
import { motion } from 'framer-motion';
import { X, Plus, Check, Minus } from 'lucide-react';
import { properties, formatNaira } from '../data/mockData';
import { VerificationBadge, TierBadge } from '../components/shared/Badges';
export const Compare = () => {
  const compareList = properties.slice(0, 2);
  return <div className="min-h-screen bg-neutral-light pt-24 pb-20" data-id="element-1175">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1176">
        <div className="mb-8" data-id="element-1177">
          <h1 className="text-3xl font-serif font-bold text-primary-900 mb-2" data-id="element-1178">
            Compare Properties
          </h1>
          <p className="text-text-light" data-id="element-1179">
            Evaluate features, pricing, and verification status side-by-side.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-soft border border-neutral-200 overflow-hidden overflow-x-auto custom-scrollbar" data-id="element-1180">
          <table className="w-full min-w-[800px] text-left border-collapse" data-id="element-1181">
            <thead data-id="element-1182">
              <tr data-id="element-1183">
                <th className="p-6 w-1/4 border-b border-neutral-200 bg-neutral-50 align-bottom" data-id="element-1184">
                  <div className="text-sm font-bold text-text-light uppercase tracking-wider" data-id="element-1185">
                    Features
                  </div>
                </th>
                {compareList.map(p => <th key={p.id} className="p-6 w-1/4 border-b border-neutral-200 border-l border-neutral-100 relative group" data-id="element-1186">
                    <button className="absolute top-4 right-4 p-1.5 bg-white rounded-full shadow-sm text-text-light hover:text-error hover:bg-error/10 opacity-0 group-hover:opacity-100 transition-all" data-id="element-1187">
                      <X size={16} data-id="element-1188" />
                    </button>
                    <img src={p.images[0]} alt="" className="w-full h-40 object-cover rounded-xl mb-4" data-id="element-1189" />
                    <h3 className="font-serif font-bold text-lg text-primary-900 line-clamp-2 mb-2" data-id="element-1190">
                      {p.title}
                    </h3>
                    <div className="text-2xl font-bold text-text" data-id="element-1191">
                      {formatNaira(p.price)}
                    </div>
                  </th>)}
                {compareList.length < 3 && <th className="p-6 w-1/4 border-b border-neutral-200 border-l border-neutral-100 align-middle text-center" data-id="element-1192">
                    <button className="w-full h-40 border-2 border-dashed border-neutral-200 rounded-xl flex flex-col items-center justify-center text-text-light hover:text-secondary hover:border-secondary hover:bg-secondary/5 transition-colors" data-id="element-1193">
                      <Plus size={32} className="mb-2" data-id="element-1194" />
                      <span className="font-bold text-sm" data-id="element-1195">Add Property</span>
                    </button>
                  </th>}
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100" data-id="element-1196">
              <tr data-id="element-1197">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1198">
                  District
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100 font-medium" data-id="element-1199">
                    {p.district}
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1200"></td>}
              </tr>
              <tr data-id="element-1201">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1202">
                  Location Tier
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1203">
                    <TierBadge tier={p.tier as 1 | 2 | 3} data-id="element-1204" />
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1205"></td>}
              </tr>
              <tr data-id="element-1206">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1207">
                  Property Type
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1208">
                    {p.type}
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1209"></td>}
              </tr>
              <tr data-id="element-1210">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1211">
                  Size
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100 font-medium" data-id="element-1212">
                    {p.size}
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1213"></td>}
              </tr>
              <tr data-id="element-1214">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1215">
                  Bedrooms / Bathrooms
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1216">
                    {p.bedrooms > 0 ? `${p.bedrooms} Bed / ${p.bathrooms} Bath` : 'N/A'}
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1217"></td>}
              </tr>
              <tr data-id="element-1218">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1219">
                  Title Document
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1220">
                    {p.ownership}
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1221"></td>}
              </tr>
              <tr data-id="element-1222">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1223">
                  Verification Status
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1224">
                    <VerificationBadge status={p.verificationStatus as any} data-id="element-1225" />
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1226"></td>}
              </tr>
              <tr data-id="element-1227">
                <td className="p-6 font-bold text-text-light bg-neutral-50" data-id="element-1228">
                  Seller
                </td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1229">
                    <div className="font-bold" data-id="element-1230">{p.seller.name}</div>
                    <div className="text-xs text-text-light mt-1" data-id="element-1231">
                      {p.seller.type}
                    </div>
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1232"></td>}
              </tr>
              <tr data-id="element-1233">
                <td className="p-6 bg-neutral-50" data-id="element-1234"></td>
                {compareList.map(p => <td key={p.id} className="p-6 border-l border-neutral-100" data-id="element-1235">
                    <button className="w-full bg-primary-900 hover:bg-primary-800 text-white py-3 rounded-xl font-bold transition-colors" data-id="element-1236">
                      View Details
                    </button>
                  </td>)}
                {compareList.length < 3 && <td className="p-6 border-l border-neutral-100 bg-neutral-50/50" data-id="element-1237"></td>}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};